import { IconCheck, IconMinus } from '../../icons/tabler';
import {
  Box,
  checkboxClasses,
  Components,
  SvgIcon,
  Theme,
} from '../../material';
import { borderRadius } from '../tokens';

const CHECKBOX_SIZE = 20;
const ICON_SIZE = 16;

const CheckedIcon = () => (
  <Box
    sx={{
      width: CHECKBOX_SIZE,
      height: CHECKBOX_SIZE,
      borderRadius: borderRadius('s'),
      backgroundColor: 'primary.main',
      color: 'common.white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <SvgIcon sx={{ fontSize: ICON_SIZE }}>
      <IconCheck />
    </SvgIcon>
  </Box>
);

const IndeterminateIcon = () => (
  <Box
    sx={{
      width: CHECKBOX_SIZE,
      height: CHECKBOX_SIZE,
      borderRadius: borderRadius('s'),
      backgroundColor: 'primary.main',
      color: 'common.white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <SvgIcon sx={{ fontSize: ICON_SIZE }}>
      <IconMinus />
    </SvgIcon>
  </Box>
);

const UncheckedIcon = () => (
  <Box
    sx={{
      width: CHECKBOX_SIZE,
      height: CHECKBOX_SIZE,
      borderRadius: borderRadius('s'),
      backgroundColor: 'transparent',
      border: 1,
      borderColor: 'secondary.light',
      flexShrink: 0,
    }}
  />
);

export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  defaultProps: {
    disableRipple: true,
    size: 'small',
    icon: <UncheckedIcon />,
    checkedIcon: <CheckedIcon />,
    indeterminateIcon: <IndeterminateIcon />,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1),
      '&:hover': {
        backgroundColor: 'transparent',
      },
      [`&.${checkboxClasses.checked}:not(.${checkboxClasses.disabled}):hover`]:
        {
          '& .MuiBox-root': {
            backgroundColor: theme.palette.primary.dark,
          },
        },
      [`&.${checkboxClasses.indeterminate}:not(.${checkboxClasses.disabled}):hover`]:
        {
          '& .MuiBox-root': {
            backgroundColor: theme.palette.primary.dark,
          },
        },
      [`&.${checkboxClasses.disabled}`]: {
        '& .MuiBox-root': {
          backgroundColor: theme.palette.action.disabledBackground,
          borderColor: theme.palette.action.disabled,
          borderWidth: '1px',
        },
      },
      [`&.${checkboxClasses.disabled}.${checkboxClasses.checked}`]: {
        '& .MuiBox-root': {
          backgroundColor: theme.palette.action.disabledBackground,
          border: `1px solid ${theme.palette.action.disabled}`,
          color: theme.palette.action.disabled,
        },
      },
      [`&.${checkboxClasses.disabled}.${checkboxClasses.indeterminate}`]: {
        '& .MuiBox-root': {
          backgroundColor: theme.palette.action.disabledBackground,
          border: `1px solid ${theme.palette.action.disabled}`,
          color: theme.palette.action.disabled,
        },
      },
    }),
  },
};
